@if (deploymentInfo.active) {
  <div class="af-deployment af-deployment_{{deploymentInfo.color}}" role="status">
    <span class="af-deployment_{{deploymentInfo.color}}">{{ deploymentText() }}</span>
  </div>
}

@for (banner of banners(); track banner.id) {
  <div class="af-banner" role="alert">
    <span class="af-banner__message">{{ text(banner.message) }}</span>
    @if (isDismissible(banner)) {
      <button
        type="button"
        class="af-banner__close"
        aria-label="Dismiss"
        (click)="dismiss(banner.id)"
      >
        &times;
      </button>
    }
  </div>
}
